// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"737":"f3933e32","782":"cbdc4573","787":"feff3c60"}[chunkId] + ".chunk.js";
};